import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { FaRegStar } from "react-icons/fa";

const FALLBACK_POSTER = 'https://via.placeholder.com/342x513?text=No+Image';

const MovieCard = React.memo(({ data }) => {
    const title = data.title || data.original_name || 'Untitled';
    const posterSrc = data.poster_path
        ? `https://image.tmdb.org/t/p/w342${data.poster_path}`
        : FALLBACK_POSTER;

    return (
        <Card sx={{ width: { xs: 160, sm: 192 }, marginLeft: 'auto', marginRight: 'auto' }}>
            <CardMedia
                component="img"
                width="100%"
                height="289"
                image={posterSrc}
                alt={`Poster for ${title}`}
                loading="lazy"
            />
            <CardContent sx={{ backgroundColor: 'black', color: 'white', textWrap: 'break-word' }}>
                <Typography
                    gutterBottom
                    variant="subtitle1"
                    component="div"
                    title={title}
                    sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#B3B3B3' }}>
                    <span aria-label={`Rating: ${data.vote_average?.toFixed(1) ?? 'N/A'} out of 10, based on ${data.vote_count ?? 0} votes`}>
                        <FaRegStar aria-hidden="true" /> {data.vote_average?.toFixed(1) ?? 'N/A'} ({data.vote_count ?? 0})
                    </span>
                </Typography>
            </CardContent>
        </Card>
    );
});

export default MovieCard;
